module.exports = __webpack_public_path__ + "img/story025@2x.377d5439.webp";